import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { CustomerStrikeService } from './service/customer-strike.service';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { RequestStrikeInterface } from 'src/app/util/interfaces/request';
import { faPencil } from '@fortawesome/free-solid-svg-icons';
import { NotificationService } from 'src/app/services/notification/notification.service';

@Component({
	selector: 'register-form-customer-strike',
	templateUrl: './customer-strike.component.html',
	styleUrls: ['./customer-strike.component.scss'],
})
export class CustomerStrikeComponent implements OnInit {
	labels: any = {
		lbl_geral_cancelar: 'Cancel',
		lbl_geral_salvar: 'Save',
		lbl_successful_updated: 'Successful updated',
		lbl_geral_preencha_campo_obrigatorio: 'Please fill all the mandatory fields',
		lbl_configuracao_de_strike: 'Strike Configuration',
		lbl_modo_de_contagem_de_strike: 'Strike Counting Mode',
		lbl_strike_atual: 'Strike Atual',
		lbl_atualizacao_informacoes_strike: 'Strike Information Update',
		lbl_uma_vez_ao_dia: '1 time a day',
		lbl_duas_vezes_ao_dia: '2 times a day',
		lbl_tres_vezes_ao_dia: '3 times a day',
		lbl_quantos_strikes_por_dia: 'How Many Strikes per Day',
		lbl_intervalo_entre_strikes: 'Strike Interval',
		lbl_sem_strike: 'No Strike',
		lbl_geral_horas: 'hours',
		lbl_salvo_com_sucesso: 'Saved successfully',
		lbl_an_errour_occour: 'An error occurred. Please try again',
	};

	icons = {
		faPencil: faPencil,
	};

	constructor(
		private CustomerStrikeService: CustomerStrikeService,
		private ProfileService: ProfileService,
		private LabelsService: LabelsService,
		private cdr: ChangeDetectorRef,
		private notificationService: NotificationService
	) {}

	isLabelsLoading = true;
	isLoadingStrike = true;
	isUpdating = false;
	showEditForm = false;

	selectedOption: string = null;
	strikeManager: RequestStrikeInterface[] = [];

	formUpdate: RequestStrikeInterface = {
		enable_3strikes: null,
		strikes_interval: null,
		strikes_attempt: null,
	};

	ngOnInit() {
		this.LabelsService.getLabels().subscribe((labels) => {
			this.labels = labels;
			this.isLabelsLoading = false;
		});

		this.getCustomerStrike();
	}

	getCustomerStrike(): void {
		this.CustomerStrikeService.getStrikeCustomer().subscribe((strikes) => {
			this.strikeManager = strikes;
			this.isLoadingStrike = false;
			this.cdr.detectChanges();
		});
	}

	convertToMinutes(timeString: string): number {
		if (typeof timeString === 'string' && timeString.includes(':')) {
			const hoursAndMinutes = timeString.split(':');
			const hoursInMinutes = Number.parseInt(hoursAndMinutes[0], 10) * 60;
			const minutes = Number.parseInt(hoursAndMinutes[1], 10);
			return hoursInMinutes + minutes;
		} else {
			console.error('Invalid time string:', timeString);
			return 0;
		}
	}

	convertToHours(minutes: any): string {
		const hours = Math.floor(minutes / 60);
		const remainingMinutes = minutes % 60;
		return `${hours.toString().padStart(2, '0')}:${remainingMinutes.toString().padStart(2, '0')}`;
	}

	saveModification(items: RequestStrikeInterface): void {
		if (this.isUpdating) return;

		if (items.strikes_interval && items.enable_3strikes !== 0) {
			items.strikes_interval = this.convertToMinutes(items.strikes_interval).toString();
		}

		if (items.enable_3strikes === 0) {
			items.strikes_attempt = '0';
			items.enable_3strikes = 0;
			items.strikes_interval = '0';
		}

		if (
			(items.enable_3strikes !== 0 && items.strikes_attempt == '0') ||
			(items.enable_3strikes !== 0 && items.strikes_interval == '0')
		) {
			this.notificationService.setNotificationMessage(this.labels.lbl_geral_preencha_campo_obrigatorio);
		} else {
			this.isUpdating = true;
			this.CustomerStrikeService.updateStrikeClient(this.ProfileService.userData().idCustomer, items).subscribe(
				(response) => {
					this.notificationService.setNotificationMessage(this.labels.lbl_salvo_com_sucesso);
					this.showEditForm = false;
					this.getCustomerStrike();
					this.isUpdating = false;
				},
				(error) => {
					this.notificationService.setNotificationMessage(this.labels.lbl_an_errour_occour);
					console.error('Error during update:', error);
				}
			);
		}
	}

	openUpdatedForm(item: RequestStrikeInterface): void {
		this.formUpdate = { ...item };
		this.showEditForm = !this.showEditForm;
	}
}
